
import { Json } from "@/integrations/supabase/types";
import { FileAttachment } from "@/types/posit";

export const jsonToFileAttachment = (json: Json): FileAttachment | null => {
  if (!json || typeof json !== 'object') return null;
  
  const obj = json as any;
  if (!obj.id || !obj.name || !obj.mimeType || !obj.source) return null;
  
  return {
    id: String(obj.id),
    name: String(obj.name),
    mimeType: String(obj.mimeType),
    source: obj.source === 'google_drive' ? 'google_drive' : 'upload',
    url: obj.url ? String(obj.url) : undefined
  };
};

export const fileAttachmentToJson = (attachment: FileAttachment): Json => {
  return {
    id: attachment.id,
    name: attachment.name,
    mimeType: attachment.mimeType,
    // Some processors expect `type`; include it mirroring mimeType
    type: attachment.mimeType,
    source: attachment.source,
    url: attachment.url
  };
};
